import { render, staticRenderFns } from "./CertificateTemplateEditor.html?vue&type=template&id=bc85c81c&scoped=true&external"
import script from "./CertificateTemplateEditor.vue?vue&type=script&lang=js"
export * from "./CertificateTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./CertificateTemplateEditor.scss?vue&type=style&index=0&id=bc85c81c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc85c81c",
  null
  
)

export default component.exports